import ApiUrl from "./ApiUrl";

export const UpdateHeaderBlock = (data) => {
   // lista de todos los usuarios
   // endDate es el total de horas
   const service = `${ApiUrl}headerBlocks/update`;
   const options = {
      method: "POST",
      //mode: "no-cors",
      body: data,
      headers: {
         "Content-Type": "multipart/form-data",
      },
   };
   delete options.headers["Content-Type"];
   return fetch(service, options);
};
export const InfoHeaderBlock = (type) => {
   const service = `${ApiUrl}headerBlocks/list`;
   const data = {type: type, token: localStorage.getItem("domecq_token")};
   return fetch(service, {
      method: "POST",
      body: JSON.stringify({...data}),
      headers: {
         "Content-Type": "application/json",
      },
   });
};

/// home

export const ListSlides = () => {
   // lista de todos los usuarios
   // endDate es el total de horas
   const service = `${ApiUrl}slidesHome/list`;
   return fetch(service);
};

//slidesHome
export const CreateSlideHome = (data) => {
   // lista de todos los usuarios
   // endDate es el total de horas
   const service = `${ApiUrl}slidesHome/register`;
   const options = {
      method: "POST",
      //mode: "no-cors",
      body: data,
      headers: {
         "Content-Type": "multipart/form-data",
      },
   };
   delete options.headers["Content-Type"];
   return fetch(service, options);
};
export const UpdateSlideHome = (data) => {
   // lista de todos los usuarios
   // endDate es el total de horas
   const service = `${ApiUrl}slidesHome/update`;
   const options = {
      method: "POST",
      //mode: "no-cors",
      body: data,
      headers: {
         "Content-Type": "multipart/form-data",
      },
   };
   delete options.headers["Content-Type"];
   return fetch(service, options);
};
// academy
export const ListAcademyService = () => {
   const service = `${ApiUrl}domecqAcademyContent/list`;
   return fetch(service);
   /* 
   const data = {...dat, token: localStorage.getItem("domecq_token")};
   return fetch(service, {
      method: "POST",
      body: JSON.stringify({...data}),
      headers: {
         "Content-Type": "application/json",
      },
   }); */
};

export const UpdateDomecqAcademy = (data) => {
   // lista de todos los usuarios
   // endDate es el total de horas
   const service = `${ApiUrl}domecqAcademy/update`;
   const options = {
      method: "POST",
      //mode: "no-cors",
      body: data,
      headers: {
         "Content-Type": "multipart/form-data",
      },
   };
   delete options.headers["Content-Type"];
   return fetch(service, options);
};

// blocks
export const ListHomeBlocks = () => {
   const service = `${ApiUrl}homeBlocks/list`;
   return fetch(service);
};
export const UpdateBlockHome = (dat) => {
   const service = `${ApiUrl}homeBlocks/update`;
   const data = {...dat, token: localStorage.getItem("domecq_token")};
   return fetch(service, {
      method: "POST",
      body: JSON.stringify({...data}),
      headers: {
         "Content-Type": "application/json",
      },
   });
};

export const CreateBlockHome = (dat) => {
   const service = `${ApiUrl}homeBlocks/register`;
   const data = {...dat, token: localStorage.getItem("domecq_token")};
   return fetch(service, {
      method: "POST",
      body: JSON.stringify({...data}),
      headers: {
         "Content-Type": "application/json",
      },
   });
};

export const HistoryCourses = (idUser) => {
   const service = `${ApiUrl}courseHistory/listByUser`;
   const data = {idUser, token: localStorage.getItem("domecq_token")};
   return fetch(service, {
      method: "POST",
      body: JSON.stringify({...data}),
      headers: {
         "Content-Type": "application/json",
      },
   });
};
export const SubscribeCourse = (dat) => {
   const service = `${ApiUrl}courseHistory/register`;
   const data = {...dat, token: localStorage.getItem("domecq_token")};
   return fetch(service, {
      method: "POST",
      body: JSON.stringify({...data}),
      headers: {
         "Content-Type": "application/json",
      },
   });
};
export const ListResourcesCourses = (idCourse) => {
   const service = `${ApiUrl}resources/listByCourse`;
   const data = {idCourse};
   return fetch(service, {
      method: "POST",
      body: JSON.stringify({...data}),
      headers: {
         "Content-Type": "application/json",
      },
   });
};
export const ThemaryCoursesService = (idCourse) => {
   const service = `${ApiUrl}temaryClasses/list`;
   const data = {idCourse};
   return fetch(service, {
      method: "POST",
      body: JSON.stringify({...data}),
      headers: {
         "Content-Type": "application/json",
      },
   });
};
export const SubthemeCourseService = (idTemaryClasses) => {
   const service = `${ApiUrl}temarySubclasses/list`;
   const data = {idTemaryClasses};
   return fetch(service, {
      method: "POST",
      body: JSON.stringify({...data}),
      headers: {
         "Content-Type": "application/json",
      },
   });
};
// experiencias
export const TestimonialCourseService = (idCourse) => {
   const service = `${ApiUrl}testimonials/listByCourse`;
   const data = {idCourse};
   return fetch(service, {
      method: "POST",
      body: JSON.stringify({...data}),
      headers: {
         "Content-Type": "application/json",
      },
   });
};

export const FacilitatorsCourseService = (idCourse) => {
   const service = `${ApiUrl}facilitatorCourses/listByCourse`;
   const data = {idCourse};
   return fetch(service, {
      method: "POST",
      body: JSON.stringify({...data}),
      headers: {
         "Content-Type": "application/json",
      },
   });
};
// forms
export const SendFormService = (data) => {
   const service = `${ApiUrl}forms/register`;
   return fetch(service, {
      method: "POST",
      body: JSON.stringify({...data}),
      headers: {
         "Content-Type": "application/json",
      },
   });
};

// home

export const SlidesHomeService = (data) => {
   const service = `${ApiUrl}slidesHome/list`;
   return fetch(service);
};
export const BlocksHomeService = (data) => {
   const service = `${ApiUrl}homeBlocks/list`;
   return fetch(service);
};
export const getHomeBlocks = (data) => {
   const service = `${ApiUrl}slidesHome/list`;
   return fetch(service, {
      method: "POST",
      body: JSON.stringify({...data}),
      headers: {
         "Content-Type": "application/json",
      },
   });
};
